export default String.raw`
.newsletterPopup {
    &__body {
        padding: 24px 16px;
        width: 80%;
    }

    &__header {
        h2 {
            @include h3-headline;
        }
    }

    &__content {
        flex-direction: column;
        padding-top: 16px;
        row-gap: 16px;

        &-right {
            width: 100%;
        }
    }
}
`